import { Spinner } from 'avo-ui'

export const TabBeautyProfile = ({ dataBeautyProfile, isLoading }) => {
    return (
        <div className={'flex flex-col space-y-8 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <p className={'text-base text-[#05308D] font-bold italic uppercase'}>Beauty Profile</p>
                    {dataBeautyProfile?.map((data, index) => (
                        <div key={index} className={'flex flex-col space-y-3'}>
                            <p className={'text-[#707071] capitalize font-semibold'}>{data?.beauty_profile}</p>
                            <div className={'flex space-x-4'}>
                                {data?.items?.map((i, index) => (
                                    <div
                                        key={index}
                                        className={
                                            'w-32 p-4 flex flex-col space-y-4 items-center justify-center border rounded-[4px]'
                                        }
                                    >
                                        <img src={i?.image_url} alt={'icon'} className={'w-16 h-16'} />
                                        <p className={'text-[#2B2B2B] capitalize'}>{i?.name}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </>
            )}
        </div>
    )
}
